<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-ruler`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M30.698 2.414a2 2 0 012.829 0l12.19 12.19c.687.688.656 1.835-.072 2.562l-28.48 28.48c-.726.727-1.873.758-2.561.07l-12.19-12.19a2 2 0 010-2.828L30.698 2.414zm-20.427 25.41L6.123 31.97l9.869 9.869 25.847-25.847-9.869-9.869-4.823 4.824c.06.039.117.084.17.137l4.396 4.396a1 1 0 010 1.415l-1.291 1.29a1 1 0 01-1.415 0l-4.396-4.396a1.002 1.002 0 01-.136-.17l-4.092 4.092c.06.038.117.084.17.137l5.688 5.687a1 1 0 010 1.414l-1.292 1.292a1 1 0 01-1.414 0l-5.688-5.688a1.002 1.002 0 01-.136-.17l-4.768 4.768c.06.038.117.084.17.137l4.396 4.396a1 1 0 010 1.414l-1.29 1.291a1 1 0 01-1.415 0l-4.396-4.396a1.012 1.012 0 01-.137-.17z"/></svg>
</template>
<script>

export default {
  name: 'IconRuler',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
